import { render, staticRenderFns } from "./imgs_container.vue?vue&type=template&id=38f2f92b"
import script from "./imgs_container.vue?vue&type=script&lang=js"
export * from "./imgs_container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports